import { ItemCard } from "@coworker/apprestructured/src/shared/components/item-cards/ItemCard/ItemCard";
import { ItemDelivery } from "@coworker/apprestructured/src/shared/components/item-cards/ItemDelivery/ItemDelivery";
import { ItemDescription } from "@coworker/apprestructured/src/shared/components/item-cards/ItemDescription/ItemDescription";
import { ItemImage } from "@coworker/apprestructured/src/shared/components/item-cards/ItemImage/ItemImage";
import { ItemName } from "@coworker/apprestructured/src/shared/components/item-cards/ItemName/ItemName";
import { ItemNo } from "@coworker/apprestructured/src/shared/components/item-cards/ItemNo/ItemNo";
import { ItemStockAndEds } from "@coworker/apprestructured/src/shared/components/item-cards/ItemStockAndEds/ItemStockAndEds";
import { ItemStockInfo } from "@coworker/apprestructured/src/shared/hooks/item/useItemStock";
import styles from "@coworker/apprestructured/src/shared/styles/common-styles.module.css";
import { Item } from "@coworker/apprestructured/src/shared/types/item";

interface ItemCardDefaultProps {
  item: Item;
  itemStock?: ItemStockInfo;
  disableItemStockQuery?: boolean;
}

export const ItemCardDefault = ({
  item,
  itemStock,
  disableItemStockQuery,
}: ItemCardDefaultProps) => {
  return (
    <ItemCard>
      <div className={styles["item-card-root-row"]}>
        <ItemImage imageUrl={item.imageUrl || item.smallImageUrl || ""} />
        <div className={styles["item-card-root-column"]}>
          <ItemName name={item.name} />
          <ItemNo itemNo={item.noFormatted} />
          <ItemDescription description={item.description || ""} />
          <ItemStockAndEds
            itemNo={item.no}
            itemType={item.type}
            itemStock={itemStock}
            disableItemStockQuery={disableItemStockQuery}
          />
          <ItemDelivery itemNo={item.no} />
        </div>
      </div>
    </ItemCard>
  );
};
